import { createAsyncThunk } from "@reduxjs/toolkit";
import { BlogApi } from "api/blog";
import { BlogContentListLPayLoad } from "api/blog/type";

export const getListCategoryBlog = createAsyncThunk(
  "blog/getListBank",
  async (_, { rejectWithValue }) => {
    try {
      const response = await BlogApi.getListCategoryBlog();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListContentBlog = createAsyncThunk(
  "blog/getListContentBlog",
  async (formData: BlogContentListLPayLoad, { rejectWithValue }) => {
    try {
      const response = await BlogApi.getListContentBlog(formData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getContentBlogDetail = createAsyncThunk(
  "blog/getContentBlogDetail",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const response = await BlogApi.getContentBlogDetail({ id });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
